import React from "react"
import "semantic-ui-css/semantic.min.css"

import BankReconciliationPageView from "./BankReconciliation.components/BankReconciliationPageView"
import useBankReconciliationPage from './BankReconciliation.logic/useBankReconciliationPage'
import withAuthentication from '../../../src/loaders/withAuthentication'

const BankReconciliation = () => {
  const logic = useBankReconciliationPage()

  return (
    <BankReconciliationPageView
      {...logic}
    />
  )
}

export default withAuthentication(BankReconciliation)
